import { Image, Page } from '@react-pdf/renderer'
import { pick } from 'lodash-es'
import type { Listing } from '~/models'
import { type ReportPdfOptions } from '~/models'
import { tw } from '../tw'

export default function PdfMapPage({
  listings,
  orientation,
}: {
  listings: Listing[]
  pdfOptions: ReportPdfOptions
  orientation: 'portrait' | 'landscape'
}) {
  const reportMapUrl =
    'https://us-central1-resimplifi-1566929291680.cloudfunctions.net/associate-report-map'

  const listingArgs = encodeURIComponent(
    JSON.stringify(
      listings.map((listing) => pick(listing, ['location', 'type', 'status']))
    )
  )
  const reportImageUrl = `${reportMapUrl}?orientation=${orientation}&listings=${listingArgs}`

  if (!reportMapUrl) {
    return null
  }

  return (
    <Page size="LETTER" orientation={orientation}>
      <Image style={tw('h-full w-full')} src={reportImageUrl} />
    </Page>
  )
}
